import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { ShieldCheck, HardHat, FileCheck2 } from 'lucide-react';

const WhyUsSection: React.FC = () => {
  return (
    <SectionWrapper>
      <div className="text-center max-w-4xl mx-auto mb-16">
        <h2 className="text-3xl md:text-5xl font-black mb-6 text-primary tracking-tight">
            Warum rombus? 
            <span className="block text-2xl md:text-3xl text-gray-500 font-bold mt-2">Spezialisierte Technik für die Reinigung technischer Infrastruktur.</span>
        </h2>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        <div className="flex flex-col items-start p-10 bg-white border border-divider rounded-2xl hover:shadow-xl transition-all duration-300">
            <div className="mb-6 p-4 bg-surface border border-divider rounded-2xl">
                <ShieldCheck className="w-8 h-8 text-accent" />
            </div>
            <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-accent mb-3">01. Running Systems</h3>
            <h4 className="text-xl font-bold mb-4 text-primary">Schutz für «Running Systems»</h4>
            <p className="text-gray-600 leading-relaxed">
                Wir schützen technische Infrastruktur während Bauphasen. Unsere Teams sind ESD-geschult und kennen die spezifischen Anforderungen aktiver Hardware – damit der Betrieb Ihres Kunden unterbruchfrei weiterläuft.
            </p>
        </div>

        <div className="flex flex-col items-start p-10 bg-white border border-divider rounded-2xl hover:shadow-xl transition-all duration-300">
            <div className="mb-6 p-4 bg-surface border border-divider rounded-2xl">
                <HardHat className="w-8 h-8 text-accent" />
            </div>
            <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-accent mb-3">02. Projektintegration</h3>
            <h4 className="text-xl font-bold mb-4 text-primary">Nahtloser Bauablauf</h4>
            <p className="text-gray-600 leading-relaxed">
                Wir integrieren uns in Ihren Bauplan. Ob nachts, am Wochenende oder in Randzeiten: Wir arbeiten so, dass Ihre Handwerker und die IT-Systeme nicht behindert werden.
            </p>
        </div>

        <div className="flex flex-col items-start p-10 bg-white border border-divider rounded-2xl hover:shadow-xl transition-all duration-300">
            <div className="mb-6 p-4 bg-surface border border-divider rounded-2xl">
                <FileCheck2 className="w-8 h-8 text-accent" />
            </div>
            <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-accent mb-3">03. SIA-Kompatibilität</h3>
            <h4 className="text-xl font-bold mb-4 text-primary">Rechtssichere Abnahme</h4>
            <p className="text-gray-600 leading-relaxed">
                Nach Projektabschluss erhalten Sie eine detaillierte Dokumentation inkl. Messwerten nach ISO 14644-1. Dies dient als Ihr Nachweis für eine SIA-kompatible Übergabe an den Bauherrn.
            </p>
        </div>
      </div>
    </SectionWrapper>
  );
};

export default WhyUsSection;